import UserAPIService from "../user_api_service";
import { API_BASE_URL } from "../../../../core/constants/app_constants";
import axios from "axios";
import apiUtil from "../../../../core/utils/api_utils";

class UserAPIServiceImpl extends UserAPIService {
  static #instance = null; // Private static instance

  constructor() {
    if (UserAPIServiceImpl.#instance) {
      return UserAPIServiceImpl.#instance; // Return existing instance instead of creating a new one
    }
    super(); // Call parent constructor
    UserAPIServiceImpl.#instance = this; // Store instance
  }

  async login(data) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/login`, data);
      return response.data;
    } catch (err) {
      return err.response ? err.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  async register(data) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/register`, data);
      return response.data;
    } catch (err) {
      return err.response ? err.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  async getUser(token, data) {
    try {
      // console.log(data, token)
      // let config = {
      //     method: 'get',
      //     url: `${API_BASE_URL}/api/user-details`,
      //     headers: {
      //       'Authorization': `Bearer ${token}`,
      //       'Content-Type': 'application/json'
      //     },
      //     data : data
      //   };
      // const response = await axios.request(config);
      // return response.data;
      const res = await apiUtil.get("/api/user-details", data);
      return res.data;
    } catch (err) {
      const errorResult = err.response ? err.response.data : { success: false, message: "Something went wrong", data: [] };
      console.log("GET USER ERROR", errorResult);
      return errorResult;
    }
  }

  /**
   * Validate OTP
   * @param {object} data - The data contains the email and otp
   * @returns {object} - The response data from the server
   */
  async validateOtp(data) {
    try {
      /**
       * Posts the data to the server and returns the response data
       * @return {Promise<object>} - The response data from the server
       */
      console.log(data);
      const response = await axios.post(`${API_BASE_URL}/api/auth/verify-otp`, data);
      return response.data;
    } catch (e) {
      /**
       * Handle any errors that may occur
       * @return {object} - The error response data
       */
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  /**
   * Resends the OTP to the user
   * @param {string} email - The email address of the user
   * @returns {object} - The response data from the server
   */
  async resendOtp(email) {
    try {
      const response = await apiUtil.post(`/api/auth/resend-otp`, { email });
      return response.data;
    } catch (e) {
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
    // return { success: true, message: "", data: [] };
    // try {
    //     // const response = await axios.post(`${API_BASE_URL}/api/resend-otp`, { email });
    //     // return response.data;
    // } catch (e) {
    //     return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    // }
  }

  async logout() {}

  async sendChangePasswordOtp(userId) {
    try {
      // return {success: true, message: "OTP sent successfully", data: []};
      const response = await apiUtil.post(`/api/auth/send-change-password-otp`, { userId });
      console.log("JHS response", response);
      return response.data;
    } catch (e) {}
  }

  async validateChangePassOTP(userId, otp) {
    try {
      const response = await apiUtil.post(`/api/auth/validate-change-password-otp`, { userId, otp });
      console.log("JHS response", response);
      return response.data;
    } catch (e) {
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  async changePassword(data) {
    try {
      const response = await apiUtil.post(`/api/auth/change-password`, data);
      console.log("JHS response", response);
      return response.data;
    } catch (e) {
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  async sendRecoveryLink(email) {
    try {
      const response = await apiUtil.post(`/api/auth/send-recovery-link`, { email });
      console.log("JHS response", response);
      return response.data;
    } catch (e) {
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  async validateRecoveryLink(token) {
    try {
      const response = await apiUtil.post(`/api/auth/validate-recovery-link`, { token });
      console.log("JHS response", response);
      return response.data;
    } catch (e) {
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  async resetPassword(token, password) {
    try {
      const response = await apiUtil.post(`/api/auth/reset-password`, { token, password });
      console.log("JHS response", response);
      return response.data;
    } catch (e) {
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  async sendOTP(email) {
    try {
      const response = await apiUtil.post(`/api/auth/send-otp`, { email });
      return response.data;
    } catch (e) {
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  async validateOTP(data) {
    try {
      console.log("JHS data", data);
      const response = await apiUtil.post(`/api/auth/validate-otp`, data);
      return response.data;
    } catch (e) {
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  async updateProfile(data) {
    try {
      console.log("JHS data", data);
      const response = await apiUtil.post(`/api/auth/edit-profile`, data);
      return response.data;
    } catch (e) {
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  async userChangePassword(data) {
    try {
      console.log("JHS data", data);
      const response = await apiUtil.post(`/api/user/change-password`, data);
      return response.data;
    } catch (e) {
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  async userSendContactUs(data) {
    try {
      const response = await apiUtil.post(`/api/profile/contact`, data);
      return response.data;
    } catch (e) {
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  async userSendFeedBack(data) {
    try {
      const response = await apiUtil.post(`/api/profile/feedback`, data);
      return response.data;
    } catch (e) {
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }

  async userSendPublicContactUs(data) {
    try {
      const response = await apiUtil.post(`/api/site/send-message`, data);
      return response.data;
    } catch (e) {
      return e.response ? e.response.data : { success: false, message: "Something went wrong", data: [] };
    }
  }
}

export default UserAPIServiceImpl;
